import { AppConfigService } from './../common/services/app-config.service';
import { Component, OnInit, DoCheck, TemplateRef, ElementRef, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Route, NavigationStart, NavigationEnd } from '@angular/router';
import { HttpRequestService } from '../common/services/http-request.service';
import { AuthService } from '../auth/auth.service';
import { Utils } from '../common/services/utils.service';
import { DashboardService } from '../dashboard/dashboard.service';
import { ConfirmationService } from 'primeng/api';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { DialogService } from 'primeng/dynamicdialog';
import { environment } from 'src/environments/environment';
import { WeatherComponent } from './weather/weather.component';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { DataprivacyComponent } from './dataprivacy/dataprivacy.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [DialogService, DashboardService]
})
export class HomeComponent implements OnInit, OnDestroy {

  constructor(private router: Router,
    private appConfigService: AppConfigService,
    private authService: AuthService,
    private route: Router,
    private httpService: HttpRequestService,
    private utils: Utils,
    private dashboardService: DashboardService,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService) { }

  transactionsItems: object[] = [];
  masterItems: object[] = [];
  routeUrlConfigs: object = this.appConfigService.getRouteUrlConfigs();
  showSidebar = false;
  isDashboard = false;
  loggerUserDetails: any;
  pwdDetails: Object;
  reportsItems: Object[] = [];
  currentAppVersion = environment.appVersion;
  showConfirmDialog = true;
  canShowPMS = false;
  printQrId: string;
  mouseEnteredToQRCode = false;
  showDependentList = false;
  dependantList: any[];
  popupTitle: string;
  footerSection: TemplateRef<any>;
  isShowWeatherModal=false;
  notificationCount: number;
  isShowNotification:boolean = true;

  fetchDashboardConsoleItems() {
    this.loggerUserDetails = this.authService.getLoggedUserName();
    if (!this.loggerUserDetails) {
      this.utils.showNotification('You have been logged out', 'Warning', 'Warn');
      this.router.navigate(['/login']);
      return;
    }

    const requestData = this.utils.constructRequestData(null, 'CoreAdminService', 'fetchConsoleTransactions');

    this.httpService.configRequestDataWithHeaders(requestData, 'post', '').subscribe(
      (response) => {
         this.notificationCount = response.hdrcache[0].notificationCount;
if(response.hdrcache[0].isShowNotification == 'true') {
         this.isShowNotification = true;
          }
else if(response.hdrcache[0].isShowNotification == 'false') {
         this.isShowNotification = false;
          }

          this.partitionModules(response.grid_array[0].ConsoleTransaction, response.hdrcache);
      }, (err) => {
        this.partitionModules(this.authService.dashboardItems);
      }
    );
  }

  partitionModules(gridArray, hdrcache?) {
    gridArray.forEach((element) => {

      if(element.ENTRY_ID == 'WTHR'){
        this.isShowWeatherModal = true;
      }

      if (element.entityType === 'transaction' || this.loggerUserDetails.ROLE_NAME === 'Admin') {
        this.transactionsItems.push(element);
      } else if (element.entityType === 'master') {
        this.masterItems.push(element);
      } else if (element.entityType === 'report') {
        this.reportsItems.push(element);
      }
    });

    this.showDataPrivacy(hdrcache);
    
}

  onNavigateToSelectedComponent(url: string, moduleName: string) {
    this.showSidebar = false;
    if (moduleName === 'LPR') {
      this.router.navigate(['/app/transaction/linear-pax-request/summary']);
      return;
    } else if (moduleName === 'SM') {
      this.router.navigate(['/app/transaction/shuttle-management/summary']);
      return;
    }
    const route = this.routeUrlConfigs[url];
    if (moduleName === 'master' || moduleName === 'transaction') {
      if (route) {
        this.route.navigate([route]);
      }
    } else if (moduleName === 'reports') {
      this.route.navigate([route]);
    }
  }

  onLogout() {
    this.utils.setHideParentCondirmDialog(true);
    this.showConfirmDialog = true;
    this.confirmationService.confirm({
      message: 'Are you sure want to logout?',
      header: 'Logout Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Yes',
      rejectLabel: 'No',
      rejectVisible: true,
      accept: () => {
        this.authService.logout();
        this.router.navigate(['/login']);
      },
      reject: () => {
      }
    });
  }

  onChangePassword() {
    const scope = this;
    const ref = scope.dialogService.open(ChangePasswordComponent, {
      data: { 'pwdDetails': scope.pwdDetails },
      header: ('Change Password'),
      width: '35%'
    });

    ref.onClose.subscribe(() => {
    });
  }

  downloadLocationDir() {
    const url = 'assets/templates/Location_Directory_Rev_1.0-01052020.xlsx';
    const downloadName = 'Location_Directory_Rev_1.0-01052020.xlsx';
    this.utils.downloadSystemFile(url, downloadName);
  }

  onOpenPMS() {
    this.router.navigateByUrl('/app/pms');
  }

  onEnterQrCode(value?) {
    if (value) {
      this.printQrId = value.rf_id;
      this.popupTitle = value.dependent_name;
    } else {
      const userDetails = this.authService.getLoggedUserDetails();
      this.printQrId = userDetails.strUserId;
      this.popupTitle = userDetails.USER_NAME;
    }
    this.mouseEnteredToQRCode = true;
  }

  onLeaveQrCode() {
    // this.qrId = this.employeeCreateConfig.formGroup.getRawValue().strEmployeeCode;
    this.mouseEnteredToQRCode = false;
  }

  onPrintQr(elemId) {
    let elem = document.getElementsByClassName('qrcode');
    let canvasElem;
    for (let i = 0; i < elem.length; i++) {
      const parentElem = elem[i].parentElement.parentElement;
      if (parentElem.id === 'qr') {
        canvasElem = elem[i].children[0];
      }
    }
    var dataUrl = canvasElem.toDataURL(); //attempt to save base64 string to server using this var  
    var windowContent = '<!DOCTYPE html>';
    windowContent += '<html>'
    windowContent += '<head><title>' + this.printQrId + ' - ' + this.popupTitle + '</title></head>';
    windowContent += '<body>'
    windowContent += '<img src="' + dataUrl + '">';
    windowContent += '</body>';
    windowContent += '</html>';
    var printWin = window.open('', '', 'width=897,height=593');
    printWin.document.open();
    printWin.document.write(windowContent);
    printWin.document.close();
    printWin.focus();
    printWin.print();
    setTimeout(() => {
      printWin.close();
    });
    return false;
  }

  onClickAddDependant(op, event, actualTarget) {
    if (this.dependantList && this.dependantList.length) {
      op.show(event, actualTarget)
      return;
    }
    const formValues = this.authService.getLoggedUserDetails();
    const reqData = { strEmployeeCode: formValues.strUserId };
    const params = this.utils.constructRequestData(reqData, 'CorePassengerRequestService', 'GetDependentDtls');
    this.httpService.configRequestDataWithHeaders(params, 'post', '').subscribe(
      (response) => {
        const list = this.utils.findAndSetGridSource(response.grid_array, 'DependentDtls');
        this.dependantList = list;
        op.show(event, actualTarget);
      }
    );
  }

  ngOnInit() {
    this.fetchDashboardConsoleItems();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // end of loading paegs
        this.isDashboard = event.url === '/app/dashboard';
      }
    });
    this.utils.subscribeParentConfirmDialog();
    this.utils.getHideParentCondirmDialog().subscribe(canShow => {
      this.showConfirmDialog = canShow;
    });
    this.canShowPMS = this.authService.getLoggedUserDetails().PMS_LOGIN === 'Y';

    this.httpService.footerSection.subscribe((template: any) => {
      this.footerSection = template;
    });
    // this.authService.initIdle();

    document.getElementById('load-container').remove();
    document.getElementById('first-loader').remove();
    document.getElementById('first-loader-footer').remove();
  }

  ngOnDestroy(): void {
    this.httpService.footerSection.unsubscribe();
    this.utils.unSubscribeParentConfirmDialog();
  }

  showBellCarrier(){
    this.router.navigate(['/app/master/carrier/summary']);
  }

  showWeatherModal(open){
      const requestData = this.utils.constructRequestData(null, 'WeatherMonitorController', 'getWeatherProfiling');
      this.httpService.configRequestDataWithHeaders(requestData, 'post', '').subscribe(
        (response: any) => {
          let weatherData = null;
          let weatherProfiling = this.utils.findAndSetGridSource(response.grid_array, 'weatherProfiling');
          weatherData = weatherProfiling ? weatherProfiling[0]:null;
          if(weatherProfiling.length == 0  || open){
            const ref = this.dialogService.open(WeatherComponent, {
              data: {'weatherData':weatherData},
              header: 'How is your weather today ?',
              width: '70%',
              contentStyle: { 'max-height': '450px' },
              closable: open
            });
            // weatherData = weatherProfiling[0];
            // this.radioform.get('weatherList').setValue(weather.weatherType)
          }
         

        });
  

 
  }

  showDataPrivacy(hdrcache) {

    const ref = this.dialogService.open(DataprivacyComponent, {
      data: {},
      header: 'Data Privacy Notice and Consent from ATNM Digital Systems Users',
      width: '85%',
      height: '68%',
      contentStyle: { 'max-height': '650px' },
      closable: false
    });

    ref.onClose.subscribe((events) => {
      if (!events) { return; }
      let hdrcache = events['hdrcache'][0];

      this.confirmationService.confirm({
        message: hdrcache.strSuccessMsg ? hdrcache.strSuccessMsg : 'Saved Successfully',
        header: 'Success',
        icon: 'fa fa-check-circle',
        acceptLabel: 'OK',
        rejectVisible: false,
        accept: () => {
          if (this.isShowWeatherModal) {
            this.showWeatherModal(false);
          }
        },
      });
    });
  }

}
